//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CCheckBox from "@/components/CCheckBox.vue";
import CInput from "@/components/CInput.vue";
import { setUserInfo, setToken, baseUrl } from "@/utils/auth";
import SysUtils from "@/utils/sysUtils";
import UserService from "@/api/userService";

export default {
  data() {
    return {
      mobile: "",
      imgCode: "", // 图片验证码
      msgCode: "", // 短信验证码
      agree: false,
      codeImg: "", // 图片验证码图片地址
      btnText: "发送验证码",
      uuid: "",
      baseUrlStr: baseUrl()
    };
  },
  mounted() {
    this.getImgCode();
  },
  methods: {
    /**
     * 获取图片验证码
     * 先获取uuid，再根据uuid获取图片验证码地址
     */
    getImgCode() {
      UserService.getUuid()
        .then((res) => {
          this.uuid = res.uuid;
          this.codeImg = UserService.getImgCode(res.uuid);
        })
        .catch((err) => {
          this.$vux.toast.text(err.msg);
        });
    },
    /**
     * 获取短信验证码
     */
    getMsgCode() {
      if (!this.mobile) {
        this.$vux.toast.text("请填写手机号");
      } else if (!this.imgCode) {
        this.$vux.toast.text("请填写图片验证码");
      } else {
        // 1.修改按钮内容，将按钮置为不可用
        this.btnText = "59s";
        // 2.60s倒计时
        let num = 59;
        let time = setInterval(() => {
          num--;
          this.btnText = num + "s";
          if (num == 0) {
            this.btnText = "发送验证码";
            clearInterval(time);
          }
        }, 1000);
        // 3.调用获取验证码接口
        UserService.getMsgCode(this.mobile)
          .then((res) => {
            console.log(res);
            this.$vux.toast.text("已发送");
          })
          .catch((err) => {
            this.btnText = "发送验证码";
            clearInterval(time);
            this.$vux.toast.text(err.msg);
          });
      }
    },
    /**
     * 点击确认，执行登录操作
     * 校验手机号，图片验证码，短信验证码和协议是否都填写
     */
    handleLogin() {
      if (!this.mobile) {
        this.$vux.toast.text("请输入手机号");
        return;
      } else if (!this.imgCode) {
        this.$vux.toast.text("请输入图片验证码");
        return;
      } else if (!this.msgCode) {
        this.$vux.toast.text("请输入短信验证码");
        return;
      } else if (!this.agree) {
        this.$vux.toast.text("请同意用户协议");
        return;
      } else {
        // 调用绑定用户手机号登录接口
        let wechatCode = SysUtils.getUrlKey("code"); // 获取路径中的code
        if (!wechatCode) wechatCode = "";
        UserService.bindMobile(this.mobile, this.msgCode, wechatCode)
          .then((res) => {
            setUserInfo(res.data);
            setToken(res.data.accessToken); // 缓存accessToken
            let data = res.data;

            SysUtils.setThemeType(data.starLevel, this); // 设置主题

            if (data.logisticsContractStatus != 1 || data.purchaseContractStatus != 1 || data.idCardStatus != 1) {
              this.$router.push({
                path: "/remind",
                query: {
                  memberId: data.memberId,
                  companyId: data.companyId,
                },
              });
            } else {
              this.$router.push({
                path: "/robbing",
              });
            }
          })
          .catch((err) => {
            this.$vux.toast.text(err.msg);
          });
      }
    },
  },
  components: {
    CCheckBox,
    CInput,
  },
};



// WEBPACK FOOTER //
// ./src/views/user/login.vue